import { defineMessages } from 'react-intl'

export default defineMessages({
  training: {
    id: 'containers.DocumentationPage.training',
    defaultMessage: 'Training',
  },
  exploreFeatures: {
    id: 'containers.DocumentationPage.exploreFeatures',
    defaultMessage: 'Refer to the below guides and step-by-step instruction, to explore the features of your dashboard.',
  },
})